export const snapshotsConsts = {
  mods: "mods",
};
